import React from 'react';
import { useDispatch } from 'react-redux';
import { resetFormReducer } from '../../redux/jobsFilterSlice';
import CrossIcon from '@partner-facets/assets/svg/crossIcon';

import { __ } from '@wordpress/i18n';

function resetFormModule() {
	const dispatch = useDispatch();

	return (
		<div
			className='checkboxgroup__separator d-flex justify-content-between info'
			onClick={() => dispatch(resetFormReducer())}
			role='button'
			tabIndex={0}
			onKeyDown={(e) => {
				if (e.code === 'Enter') dispatch(resetFormReducer());
			}}
		>
			<span className='info__text h5'>{__('Clear all filters', 'job')}</span>
			<CrossIcon />
		</div>
	);
}

export default resetFormModule;
